import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const postSupportTicketSlice = createApi(`PostSupportTicketSlice`,"POST");

const PostSupportTicketSlice = createSlice({
  name: 'PostSupportTicketSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postSupportTicketSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postSupportTicketSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postSupportTicketSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PostSupportTicketSlice.reducer;